import React, { useContext, useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
import { Button, Textfield } from '@/components/atomics/';
import Pagebase from '@/components/organism/Pagebase';
import styles from './Setting.module.scss';
import Modal from '@/components/atomics/Modal';
import Spinner from '@/components/atomics/Spinner';
import ActionsMessage from '@/components/molecules/Actions/Message';
import { getLocalStorage } from '@/utils/storages';
import { AppContext } from '@/App';
import { useAddAmin } from '@/hooks/useAdmin';

const className = 'setting';

const ListAdmin: React.FC = () => {
  const [contentModal, setContentModal] = useState<React.ReactNode>();
  const [password, setPassword] = useState<string | undefined>(undefined);
  const [confirmedPassword, confirmPassword] = useState<string | undefined>(undefined);
  let userName = 'User Name';
  let userLevel = 100;
  const appContext = useContext(AppContext);
  const setErrorMessage = appContext?.setErrorMessage ?? (() => {});

  try {
    const userData = JSON.parse(getLocalStorage('user_data') || '{}');
    userName = userData?.username || userName;
    userLevel = userData?.level || userLevel;
  } catch {}

  const { data, error, isLoading, refetch } = useAddAmin({
    username: userName ?? '',
    password:  password ? CryptoJS.MD5(password).toString() : '',
    method: 'PUT',
    level: userLevel.toString()
  });

  let errorMessage =
    (error && typeof error === 'object' && 'response' in error && (error as any).response?.data?.message) ||
    (error && typeof error === 'object' && 'data' in error && (error as any).data?.message) ||
    error?.message ||
    '';

  useEffect(() => {
    if (errorMessage) {
      setErrorMessage(errorMessage);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (isLoading) {
      setContentModal(
        <Modal close={false} open={true}>
          <Spinner />
        </Modal>
      );
    }
  }, [isLoading]);

  useEffect(() => {
    if (data) {
      setContentModal(
        <Modal close={false} open={true} onClose={() => {
          setContentModal(undefined);
        }}>
          <ActionsMessage title="Admin Berhasil Diubah"
            message="Data admin baru telah berhasil disimpan dan siap digunakan"
            onConfirm={() => setContentModal(undefined)} />
        </Modal>
      );
    }
  }, [data]);

  const handleSubmit = () => {
    if (password !== confirmedPassword) {
      setErrorMessage('Kata sandi baru dan konfirmasi kata sandi baru tidak sesuai');
      return;
    }
    
    refetch();
  };

  return (
    <Pagebase className={styles[className]} title="Pengaturan / Profil">
      <div className={styles[className + '__card']}>
        <img
          alt="Profile"
          src="/images/profile.png"
          width="100"
          height="100"
          style={{ borderRadius: '50%' }}
        />
        <h5>
          Data Profil
        </h5>
        <Textfield
          disabled={true}
          label="Nama"
          value={userName} />
        <h5>
          Ubah Kata Sandi
        </h5>
        <Textfield
          label="Kata Sandi Baru"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Masukkan kata sandi baru"
          type="password" />
        <br />
        <Textfield
          label="Konfirmasi Kata Sandi Baru"
          onChange={(e) => {
            confirmPassword(e.target.value);
          }}
          placeholder="Ulangi kata sandi baru"
          type="password" />
        <br />
        <Button onClick={handleSubmit} variant="primary">
          Simpan
        </Button>
      </div>
      {
        contentModal
      }
    </Pagebase>
  );
};

export default ListAdmin;
